/* eslint-disable @typescript-eslint/no-unused-vars */
import { useMemo, useState, memo, useRef, useCallback } from "react";
import { Link } from "react-router-dom";
import { routes } from "@/common/utils/routes";
import { IGif, IUser } from "@/common/services/types";
import { metricsBus } from "@/common/buses";
import { CurrentUserObject } from "@/common/hooks/useVisitorInfo";
import DefaultUserIcon from "@/common/images/icons/default_userpic.svg?react";
import { className } from "@/common/utils";
import SealCheckIcon from "./images/icons/seal-check.svg?react";
import "./UserInfo.scss";

interface IUserInfoProps {
  gif: IGif;
  user: IUser;
  rel?: string;
  isFollowing: boolean;
  currentUser: CurrentUserObject | null;
  onProfileMetric: (value: string) => void;
  onFollow: () => void;
}

export const UserInfo: React.FC<IUserInfoProps> = memo(({
  gif,
  user,
  currentUser,
  isFollowing,
  onFollow,
  onProfileMetric
}) => {
  const [showMore, setShowMore] = useState(false);
  const isCurrentUserGif = currentUser?.username === user.username;
  const gifDescription = useMemo(() => gif.description || user.description, [user, gif]);

  const handleUserClick = useCallback(() => {
    onProfileMetric(user.username);
    metricsBus.emit("watchPageNavigation", { elementType: "Creator", targetURL: routes.user(user.username) });
  }, [onProfileMetric]);

  return (
    <div className="userInfo">
      <div className="userInfoWrap">
        <Link
          className="userAvatar"
          to={routes.user(user.username)}
          onClick={handleUserClick}
          aria-label={`Link to ${user.username} profile`}
        >
          {user.profileImageUrl ? <img loading="lazy" src={user.profileImageUrl} alt={`Poster for ${user.username}`}/> : <DefaultUserIcon className="avatarDefault" />}
          <span className="userName">{user.name || user.username}</span>
          {user.verified && <span title={`${user.username} is a verified RedGIFs ${user.studio ? "Studio" : "creator"}`} className="verifiedIcon"><SealCheckIcon /></span>}
        </Link>
        {!isCurrentUserGif && <button className="follow" onClick={onFollow}>{isFollowing ? "Following" : "Follow"}</button>}
      </div>
      {gifDescription && (
        <p className="description" onClick={() => setShowMore(prev => !prev)}>
          <span className={className({ "descriptionText": true, "fullText": showMore })}>
            {gifDescription}
          </span>
        </p>
      )}
    </div>
  );
});
